// extracted by mini-css-extract-plugin
export default {"mapScale":"MapScale--mapScale--S4IjA"};